// Função para criar logs detalhados do refresh token
const logRefreshToken = (level, message, data = null) => {
  const timestamp = new Date().toISOString();
  const logMessage = `[REFRESH_TOKEN][${level}][${timestamp}] ${message}`;
  
  if (level === 'ERROR') {
    console.error(logMessage, data);
  } else if (level === 'WARN') {
    console.warn(logMessage, data);
  } else {
    console.log(logMessage, data);
  }
  
  // Salvar logs no localStorage para debug
  try {
    const logs = JSON.parse(localStorage.getItem('refresh_token_logs') || '[]');
    logs.push({
      level,
      message,
      timestamp,
      data: data ? JSON.stringify(data) : null
    });
    
    // Manter apenas os últimos 50 logs
    if (logs.length > 50) {
      logs.splice(0, logs.length - 50);
    }
    
    localStorage.setItem('refresh_token_logs', JSON.stringify(logs));
  } catch (error) {
    console.error('Erro ao salvar log:', error);
  }
};

export const getUserToken = (token) => {
  try {
    logRefreshToken('INFO', 'Decodificando token JWT');
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const payload = JSON.parse(jsonPayload);
    logRefreshToken('INFO', 'Token decodificado com sucesso', { userId: payload.sub, exp: payload.exp });
    return payload;
  } catch (error) {
    logRefreshToken('ERROR', 'Erro ao decodificar token', error);
    throw error;
  }
}

// Verificar se o token está expirado
export function isTokenExpired(token) {
  if (!token) {
    logRefreshToken('WARN', 'Token não fornecido para verificação de expiração');
    return true;
  }
  
  try {
    const decoded = getUserToken(token);
    const currentTime = Date.now() / 1000;
    
    // Verifica se o token vai expirar nos próximos 5 minutos (300 segundos)
    const isExpired = decoded.exp < (currentTime + 300);
    
    logRefreshToken('INFO', 'Verificação de expiração do token', {
      exp: decoded.exp,
      currentTime,
      isExpired,
      timeToExpire: decoded.exp - currentTime
    });
    
    return isExpired;
  } catch (error) {
    logRefreshToken('ERROR', 'Erro ao verificar expiração do token', error);
    return true;
  }
}

// Verificar se o access token atual está expirado
export function isAccessTokenExpired() {
  const token = getAccessToken();
  // logRefreshToken('INFO', 'Verificando se access token atual está expirado');
  return isTokenExpired(token);
}

export function getRefreshToken() {
  const refreshToken = localStorage.getItem("refresh_token");
  // logRefreshToken('INFO', 'Obtendo refresh token do localStorage', { hasToken: !!refreshToken });
  return refreshToken;
}

export function getAccessToken() {
  const accessToken = localStorage.getItem("access_token");
  // logRefreshToken('INFO', 'Obtendo access token do localStorage', { hasToken: !!accessToken });
  return accessToken;
}

export function getUserId() {
  const userId = Number(localStorage.getItem("user-id"));
  // logRefreshToken('INFO', 'Obtendo user ID do localStorage', { userId });
  return userId;
}

export function logoutAplication() {
  logRefreshToken('INFO', 'Fazendo logout da aplicação');
  localStorage.removeItem("user-id");
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("refresh_token_logs");
  logRefreshToken('INFO', 'Logout realizado com sucesso');
}

export function setTokens(accessToken, refreshToken) {
  logRefreshToken('INFO', 'Salvando novos tokens no localStorage');
  localStorage.setItem("access_token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);
  logRefreshToken('INFO', 'Tokens salvos com sucesso');
}

// Função para obter logs de refresh token
export function getRefreshTokenLogs() {
  try {
    return JSON.parse(localStorage.getItem('refresh_token_logs') || '[]');
  } catch (error) {
    console.error('Erro ao obter logs:', error);
    return [];
  }
}

// Exportar função de log para uso em outros módulos
export { logRefreshToken };